import React from 'react';
import { Table as AntTable } from 'antd';

const CMSTable = ({ data, columns, id }) => {
    return (
        <div className="mt-3">
            <AntTable
                key={id}
                columns={columns}
                dataSource={data}
                // bordered
                pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showTotal: (total) => {
                        return (
                            <span className='color4'>{`Toplam ${total} kayıt`}</span>
                        )
                    }
                }}
                scroll={{ x: true }}
            />
        </div>
    );
};

export default CMSTable;